module.exports = "/_next/static/images/2c272a413887cf13ff9739006c75dcb4-icon_beach.png";